import {
  Component,
  ComponentRef,
  ElementRef,
  OnInit,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation,
} from "@angular/core";
import { KYMW00Model } from "src/app/commons/kymw00/kymw00.model";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessViewHelperSub } from "src/app/commons/kymw00/pless-view-helper-sub";
import { KYMW7001Model } from "./kymw7001.model";
import { CellRange, CellType, FlexGrid } from '@grapecity/wijmo.grid';
import { GetTargetListByFeatureGoodsSelectionResponse, GetTargetListByFeatureGoodsSelectionService } from "./api-services/get-target-list-by-feature-goods-selection.service";
import { GetMediumListByOrderService } from "./api-services/get-medium-list-by-order.service";
import { GetFeatureListService } from "./api-services/get-feature-list.service";
import { PlessViewUtilsSub } from "src/app/commons/kymw00/pless-view-utils-sub.service";
import { PlessAlert } from "src/app/shared/pless-alert/pless-alert.component";
import { SelectionListInfo } from "./vo/selection-list-info.model";
import { TargetListInfo } from "./vo/target_list_info.model";
import { ReplacementListInfo } from "./vo/replacement-list-info.model";
import { KYMW0300Component } from "src/app/commons/kymw03/kymw0300/kymw0300.component";
import { KYMW0300InputModel } from "src/app/commons/kymw03/kymw0300/vo/kymw0300-input.model";
import { ApprovalFeatureInfoService } from "./api-services/approval-feature-info";
import { CheckFeatureGoodsSelectionResponse, CheckFeatureGoodsSelectionService } from "./api-services/check-feature-goods-selection";
import { CheckFeatureSelectionService } from "./api-services/check-feature-selection.service";
import { ConfirmFeatureGoodsByBuyerService } from "./api-services/confirm-feature-goods-by-buyer";
import { GetFeatureThemaByBuyerService } from "./api-services/get-feature-thema-by-buyer";
import { GetReplacementGoodsResponse, GetReplacementGoodsService } from "./api-services/get-replacement-goods";
import { GetReplacementListResponse, GetReplacementListService } from "./api-services/get-replacement-list";
import { GetReplacementRequestGoodsResponse, GetReplacementRequestGoodsService } from "./api-services/get-replacement-request-goods";
import { GetSelectionGoodsListByBuyerResponse, GetSelectionGoodsListByBuyerService } from "./api-services/get-selection-goods-list-by-buyer";
import { RegistFeatureRequestBuyerService } from "./api-services/regist-feature-request-buyer";
import { RejectionFeatureInfoService } from "./api-services/rejection-feature-info";
import { GetGoodsPlanNumService } from "./api-services/get-goods-plan-num.service";
import { PlessViewUtils } from "src/app/shared/utils/pless-view-utils.service";
import { Menu } from "@grapecity/wijmo.input";
import { ActivatedRoute, Router } from "@angular/router";
import { GetCodeListService } from "src/app/commons/kymw02/api-services/get-code-list.service";
import { KYMW0300OutputModel } from "src/app/commons/kymw03/kymw0300/vo/kymw0300-output.model";
import { OrderTextWithCatalogComponent } from "src/app/commons/kymw02/text-input/order-text-with-catalog/order-text-with-catalog.component";
import { KYMW0300Model } from "src/app/commons/kymw03/kymw0300/kymw0300.model";

/**
 * 表紙特集掲載商品選定（バイヤー）を管理するクラス
 *
 * @export KYMW7001Component
 * @class KYMW7001Component
 */
@Component({
  selector: "app-kymw7001",
  templateUrl: "kymw7001.component.html",
  styleUrls: ["kymw7001.component.scss"],
  encapsulation: ViewEncapsulation.None,
})

export class KYMW7001Component extends PlessViewHelperSub implements OnInit {

  private kymw0300InputVO: KYMW0300InputModel = null;		// 商品検索画面のVO
  kymw7001Model: KYMW7001Model = new KYMW7001Model();
  
  constructor(
    private dialogService: PlessDialogServiceSub,
    private viewContainerRef: ViewContainerRef,
    private approvalFeatureInfoService: ApprovalFeatureInfoService,
    private checkFeatureGoodsSelectionService: CheckFeatureGoodsSelectionService,
    private checkFeatureSelectionService: CheckFeatureSelectionService,
    private ConfirmFeatureGoodsByBuyerService: ConfirmFeatureGoodsByBuyerService,
    private getFeatureListService: GetFeatureListService,
    private getFeatureThemaByBuyerService: GetFeatureThemaByBuyerService,
    private getGoodsPlanNumService: GetGoodsPlanNumService,
    private getMediumListByOrderService: GetMediumListByOrderService,
    private getReplacementGoodsService: GetReplacementGoodsService,
    private getReplacementListService: GetReplacementListService,
    private getReplacementRequestGoodsService: GetReplacementRequestGoodsService,
    private getSelectionGoodsListByBuyerService: GetSelectionGoodsListByBuyerService,
    private getTargetListByFeatureGoodsSelectionService: GetTargetListByFeatureGoodsSelectionService,
    private registFeatureRequestBuyerService: RegistFeatureRequestBuyerService,
    private rejectionFeatureInfoService: RejectionFeatureInfoService,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private activeRoute: ActivatedRoute,
    private route: Router,
    private getCodeListService: GetCodeListService,
  ) {
    super(kymw00Model);

    // 権限
    this.permission = this.getFuncPermission('KYMW7001');
  }

  @ViewChild('txt_OrderCode', { static: true }) txt_OrderCode: OrderTextWithCatalogComponent;

  // ボタン
  // 表示
  @ViewChild('btn_Display', { static: true }) btn_Display: ElementRef;
  // 商品検索
  @ViewChild('btn_Search', { static: true }) btn_Search: ElementRef;
  // 選定
  @ViewChild('btn_Selection', { static: true }) btn_Selection: ElementRef;
  // 選定解除
  @ViewChild('btn_SelectionCannel', { static: true }) btn_SelectionCannel: ElementRef;
  // 確定
  @ViewChild('btn_Confirm', { static: true }) btn_Confirm: ElementRef;
  // 承認
  @ViewChild('btn_Approval', { static: true }) btn_Approval: ElementRef;
  // 却下
  @ViewChild('btn_Rejection', { static: true }) btn_Rejection: ElementRef;

  // Grid
  // 選定対象
  @ViewChild('dtg_SelectionTargetList', { static: true }) dtg_SelectionTargetList: FlexGrid;
  // 候補一覧
  @ViewChild('dtg_TargetList', { static: true }) dtg_TargetList: FlexGrid;
  // 選定商品一覧
  @ViewChild('dtg_SelectionGoodsList', { static: true }) dtg_SelectionGoodsList: FlexGrid;
  // 差し替え対象一覧
  @ViewChild('dtg_ReplacementList', { static: true }) dtg_ReplacementList: FlexGrid;

  public kymw0300ComponentRef: ComponentRef<any> = null;
  public kymw0300Component: KYMW0300Component;
  public kymw0300Model: KYMW0300Model = new KYMW0300Model();

  /** 編集済みかをチェックするカウンタ */
  public editFlag: boolean = <boolean>false;

  /** モード管理(true: 確認モード, false: 選定モード) */
  public mode: boolean = <boolean>true;

  /** 特集メモ表示 */
  public featureMemoDisable: boolean = <boolean>true;

  /** ユーザ権限(0：使用不可、1：閲覧のみ、2：フルコントロール可能) */
  public permission: string = <string>'1';

  // contextmenu
  public cmReplacementListList: Menu = null;

  /**
   * 編集カウントをカウントする。
   */
  public eventEditHandler(): void {
    this.editFlag = true;
  }

  /**
   * 編集カウントをクリアする。
   */
  public clearEditCount(): void {
    this.editFlag = false;
  }

  /**
   * ステータスを変換して返却する。
   * 
   * @param requestStatus 
   * @returns 
   */
  public getRequestStatus(requestStatus: string): string {
    if (requestStatus == "0") {
      return "未依頼"
    } else if (requestStatus == "1") {
      return "依頼済"
    } else if (requestStatus == "2") {
      return "選定済"
    }
  }

  /**
   * コンポーネント初期化
   *
   * @memberof KYMW7001Component
   */
  ngOnInit(): void {
    this.kymw7001Model.FeatureList = [];

    // アコーディオン制御（全ての項目を開く）
    const detailElements = document.querySelectorAll('details.accordion')
    detailElements.forEach((item) => {
      if (item) item.setAttribute('open', 'true');
    })
    
    // 遷移元画面からパラメータを受け取る
    let paramMediumType = "";
    let paramFeatureCode = "";
    this.activeRoute.queryParams.subscribe(params => {
      if (Object.keys(params).length !== 0) {
        if ('orderCode' in params) {
          this.kymw7001Model.orderCode = params['orderCode'];
        }
        if ('catalogId' in params) {
          this.kymw7001Model.catalogId = params['catalogId'];
        }
        if ('mediumType' in params) {
          paramMediumType = params['mediumType'];
        }
        if ('featureCode' in params) {
          paramFeatureCode = params['featureCode'];
        }
        if ('buyerRequestId' in params) {
          this.kymw7001Model.buyerRequestId = params['buyerRequestId'];
        }
        // モード設定
        this.mode = false;
      }
    })
    
    // モード設定
    if (!PlessViewUtils.isEmpty(this.kymw7001Model.buyerRequestId)) {
      this.mode = false;
    }

    // バイヤーコードリスト取得
    this.getCodeListService.execute("ct357", "", this.kymw7001Model, "BuyreCodeList", () => {
      // リストにグループ長を追加
      const addItem = {
        CodeDiv: null,
        CodeValue: "99999999",
        CodeName: "グループ長",
        CodeDivName: null,
        Reserve1: null,
        Reserve2: null,
        ReserveNum1: null,
        ReserveNum2: null,
        SortNum: null,
        StartOrderCode: null,
        EndOrderCode: null,
      };
      this.kymw7001Model.BuyreCodeList = [addItem, ...this.kymw7001Model.BuyreCodeList];
      // 価格パターンリスト取得
      this.getCodeListService.execute("ct355", "", this.kymw7001Model, "PricePetternList", () => {
        // 選定モード初期表示
        if (!this.mode) this.initSelectModeData(paramMediumType, paramFeatureCode)
      });
    });

    // 選定商品一覧
    this.dtg_SelectionGoodsList.itemsSourceChanged.addHandler(() => {
      // データグリッド行の選択解除
      this.dtg_SelectionGoodsList.select(-1, -1);
    });
    this.dtg_SelectionGoodsList.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      const ht = this.dtg_SelectionGoodsList.hitTest(e);
      if ((0 <= ht.row) && (0 == ht.col) && 
          ht.target.className !== 'wj-cell wj-header wj-align-center' &&
          !ht.target.className.includes('all-selection_list-checkbox')) {
        document.getElementById(`selection_goods_list_check_${ht.row}`).click();
      }
    });

    // 差替え対象一覧
    this.dtg_ReplacementList.itemsSourceChanged.addHandler(() => {
      // データグリッド行の選択解除
      this.dtg_ReplacementList.select(-1, -1);
      // 背景色設定処理
      this.setColorPattern(this.dtg_ReplacementList);
    });
    // コンテキストメニュー作成
    this.cmReplacementListList = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          {
            header: '選定依頼', caption: '選定依頼', cmd: 'featureRequest',
            enabled: false
          },
          {
            header: '商品選定', caption: '商品選定', cmd: 'goodsSelect',
            enabled: false
          }
        ],
        command: {
          canExecuteCommand: (param: { enabled: boolean; }) => {
            return param.enabled === false ? false : true;
          },
        },
        // イベント設定
        itemClicked: () => {
          if (this.cmReplacementListList.selectedValue === 'featureRequest') this.eventFeatureRequest_CLICKHandler();
          if (this.cmReplacementListList.selectedValue === 'goodsSelect') this.eventGoodsSelect_CLICKHandler();
        }
      }
    );
    // 右クリック押下時 コンテキストメニュー表示処理
    this.dtg_ReplacementList.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止
      e.preventDefault();
      // showContextMenu()を使用すると活性制御が正しく行われないため個別で実装
      // 行選択
      const ht = this.dtg_ReplacementList.hitTest(e.pageX, e.pageY);
      if (ht.cellType === CellType.Cell) {
        // 右クリック押下時に対象行を選択状態にする
        const cr = new CellRange(ht.row, ht.col);
        this.dtg_ReplacementList.select(cr, false);
      }

      // 活性・非活性設制御
      let enableFlag = false;
      if (this.dtg_ReplacementList.selectedItems.length == 1 &&
          this.dtg_ReplacementList.selectedItems[0].requestStatus == "未依頼" && 
          this.permission == "2") {
        enableFlag = true;
      }
      if (this.dtg_ReplacementList !== undefined) {
        this.cmReplacementListList.itemsSource.forEach((item: { enabled: boolean; }) => {
          item.enabled = enableFlag;
        });
      }

      // コンテキストメニュー表示
      this.cmReplacementListList.show(e);
    });

    // 選定対象
    this.dtg_SelectionTargetList.itemsSourceChanged.addHandler(() => {
      // データグリッド行の選択解除
      this.dtg_SelectionTargetList.select(-1, -1);
    });

    // 候補一覧
    this.dtg_TargetList.itemsSourceChanged.addHandler(() => {
      // データグリッド行の選択解除
      this.dtg_TargetList.select(-1, -1);
    });
    // チェックボックスのチェック範囲設定
    if (this.dtg_TargetList) {
      this.dtg_TargetList.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
        const ht = this.dtg_TargetList.hitTest(e);
        if ((0 <= ht.row) && (0 == ht.col) && ht.target.className !== 'wj-cell wj-header wj-align-center') {
          document.getElementById(`target_list_check_${ht.row}`).click();
        }
      });
    }
    
    this.componentName = 'KYMW7001';
  }

  /**
   * データグリッド行の背景色設定
   * @param {FlexGrid} grid 処理対象データグリッド
   */
  public setColorPattern(grid: FlexGrid): void {
    // 背景色設定
    grid.rows.forEach((row) => {
      if (row.dataItem.requestStatus !== '未依頼') {
        row.cssClass = 'grid-row-request-select';
      }
    });
  }

  /**
   * 選定モード初期表示処理
   * 
   * @param paramMediumType 
   * @param paramFeatureCode 
   */
  public initSelectModeData(paramMediumType: string, paramFeatureCode: string): void {
    // 選定モード

    // 媒体リスト取得
    this.getMediumListByOrderService.execute(this.kymw7001Model, () => {
      this.kymw7001Model.mediumType = paramMediumType;
      // 特集リスト取得
      this.getFeatureListService.execute(this.kymw7001Model, () => {
        this.kymw7001Model.featureCode = paramFeatureCode;
        // 特集情報取得
        this.getFeatureThemaByBuyerService.execute(this.kymw7001Model, () => {
          // 表紙特集選定商品一覧取得
          this.getReplacementRequestGoodsService.execute(this.kymw7001Model,
            (data: GetReplacementRequestGoodsResponse) => {
              const selectionList = [];
              const addData = new SelectionListInfo();
              addData.featureCode = data[0].FeatureCode;
              addData.featureName = data[0].FeatureName;
              addData.formatFeature = this.formatCodeName(data[0].FeatureCode, data[0].FeatureName);
              addData.classCode = data[0].ClassCode;
              addData.classNameKanji = data[0].ClassName;
              addData.formatClass = this.formatCodeName(data[0].ClassCode, data[0].ClassName);
              addData.middleClassCode = data[0].MiddleClassCode;
              addData.middleClassNameKanji = data[0].MiddleClassName;
              addData.formatMiddleClass = this.formatCodeName(data[0].MiddleClassCode, data[0].MiddleClassName);
              addData.pCode = data[0].PCode;
              addData.guideGoodsName = data[0].GuideGoodsName;
              addData.guideStandardName = data[0].GuideStandardName;
              const pricePattern = this.kymw7001Model.PricePetternList.filter(
                priceItem => priceItem.CodeValue == data[0].PricePattern);
              addData.pricePattern = pricePattern.length == 1 ? pricePattern[0].CodeName : null;
              addData.thisTimeSupplyPrice = data[0].ThisTimeSupplyPrice;
              addData.thisTimeCostPrice = data[0].ThisTimeCostPrice
              addData.predictPlanNum = data[0].PredictPlanNum;
              addData.planNum = data[0].PlanNum;
              addData.planSupplyBudget = data[0].PlanSupplyBudget;
              addData.dispPlanSupplyBudget = this.setDispPlanSupplyBudget(data[0].PlanSupplyBudget);
              addData.gpr = 
                this.calculateGPR(data[0].PlanSupplyBudget, data[0].PredictPlanNum, data[0].PlanNum, data[0].ThisTimeCostPrice);
              addData.remarks = data[0].Remarks;
              addData.buyerRequestId = data[0].BuyerRequestId;
              addData.itemCode = data[0].ItemCode;
              selectionList.push(addData)
              this.kymw7001Model.SelectionTargetList = selectionList;
            }
          );
        });
      });
    });
  }

  /**
   * 受注コード(テキストインプット)_変更時に呼び出される
   *
   * @memberof KYMW7001Component
   */
  public eventOrderCode_CHANGEHandler(): void {
    this.clearDisplay();
    if (this.txt_OrderCode.isValidOrderCode()) {
      // 媒体リスト取得
      this.getMediumListByOrderService.execute(this.kymw7001Model);
    } else {
      this.kymw7001Model.MediumList = [];
      this.kymw7001Model.mediumType = '';
      this.kymw7001Model.FeatureList = [];
      this.kymw7001Model.featureCode = '';
    }
  }

  /**
   * 媒体(コンボボックス)_変更時に呼び出される
   *
   * @memberof KYMW7001Component
   */
  public eventMediumType_CHANGEHandler(): void {
    if (this.kymw7001Model.mediumType === 'blankVal') this.kymw7001Model.mediumType = '';
    this.clearDisplay();
    if (this.txt_OrderCode.isValidOrderCode() && this.isValidMediumType()) {
      // 特集リスト取得
      this.getFeatureListService.execute(this.kymw7001Model);
    } else {
      this.kymw7001Model.FeatureList = [];
      this.kymw7001Model.featureCode = '';
    }
  }

  /**
   * 特集(コンボボックス)_変更時に呼び出される
   *
   * @memberof KYMW7000Component
   */
  public eventFeatureType_CHANGEHandler(): void {
    if (this.kymw7001Model.featureCode === 'blankVal') this.kymw7001Model.featureCode = '';
    this.clearDisplay();
  }

  /**
   * 表示クリア
   *
   * @memberof KYMW7001Component
   */
  private clearDisplay(): void {
    this.clearEditCount();
    this.kymw7001Model.featureMemo = '';
    this.kymw7001Model.SelectionTargetList = [];
    this.kymw7001Model.TargetListInfo = [];
    this.kymw7001Model.SelectionList = [];
    this.kymw7001Model.ReplacementList = [];
  }

  /**
   * 特集メモ_変更時に呼び出される
   *
   * @memberof KYMW7001Component
   */
  public eventFeatureMemo_CHANGEHandler() {
    this.eventEditHandler();
  }

  /**
   * 価格パターン(セレクトボックス)_変更時に呼び出される
   *
   * @memberof KYMW7001Component
   */
  public eventPricePettern_CHANGEHandler(item: any): void {
    this.eventEditHandler();

    // 価格パターンがブランク値の場合は空文字に変換
    if (item.pricePattern === 'blankVal') {
      item.pricePattern = '';
    }

    // 今回供給価格と仕入価格を価格パターンの値によって設定
    this.setSupplyPriceAndCostPrice(item);

    // 計画供給高計算
    this.calculatePlanSupplyBudget(item);

    // GPRの計算
    const gpr = this.calculateGPR(item.planSupplyBudget, item.predictPlanNum, item.planNum, item.thisTimeCostPrice);
    if (this.validateGPR(gpr, item)) item.gpr = gpr;

    // 表示更新
    this.dtg_SelectionGoodsList.refresh();
  }

  /**
   * 今回供給価格と仕入価を価格パターンの値によって設定
   * 
   * @memberof KYMW7001Component
   * @param item 
   */
  public setSupplyPriceAndCostPrice(item: any): void {
    // Pコードが不正な場合はブランクとする
    if (PlessViewUtilsSub.isEmpty(item.pCode) || !PlessViewUtilsSub.validatePCode(item.pCode)) {
      item.thisTimeSupplyPrice = null;
      item.thisTimeCostPrice = null;
      return;
    }

    // 今回供給価格と仕入価格を反映
    if (item.pricePattern == "0") {
      // 通常の場合は通常価格を使用
      item.thisTimeSupplyPrice = item.supplyPriceStandard;
      item.thisTimeCostPrice = item.costPriceStandard;
    } else if (item.pricePattern == "1") {
      // 特1の場合は特1価格を使用
      item.thisTimeSupplyPrice = item.supplyPriceSpecial1;
      item.thisTimeCostPrice = item.costPriceSpecial1;
    } else if (item.pricePattern == "2") {
      // 特2の場合は特2価格を使用
      item.thisTimeSupplyPrice = item.supplyPriceSpecial2;
      item.thisTimeCostPrice = item.costPriceSpecial2;
    } else {
      item.thisTimeSupplyPrice = null;
      item.thisTimeCostPrice = null;
    }
  }

  /**
   * 今回供給価格_変更時に呼び出される
   *
   * @memberof KYMW7001Component
   */
  public eventThisTimeSupplyPrice_CHANGEHandler(item: any): void {
    this.eventEditHandler();

    // 計画供給高計算
    this.calculatePlanSupplyBudget(item);

    // GPRの計算
    const gpr = this.calculateGPR(item.planSupplyBudget, item.predictPlanNum, item.planNum, item.thisTimeCostPrice);
    if (this.validateGPR(gpr, item)) item.gpr = gpr;

    // 表示更新
    this.dtg_SelectionGoodsList.refresh();
  }

  /**
   * 仕入価_変更時に呼び出される
   *
   * @memberof KYMW7001Component
   */
  public eventThisTimeCostPrice_CHANGEHandler(item: any): void {
    this.eventEditHandler();

    // GPRの計算
    const gpr = this.calculateGPR(item.planSupplyBudget, item.predictPlanNum, item.planNum, item.thisTimeCostPrice);
    if (this.validateGPR(gpr, item)) item.gpr = gpr;

    // 表示更新
    this.dtg_SelectionGoodsList.refresh();
  }

  /**
   * 計画数(修正)_変更時に呼び出される
   *
   * @memberof KYMW7001Component
   */
  public eventPlanNum_CHANGEHandler(item: any): void {
    this.eventEditHandler();

    // 計画供給高計算
    this.calculatePlanSupplyBudget(item);

    // GPRの計算
    const gpr = this.calculateGPR(item.planSupplyBudget, item.predictPlanNum, item.planNum, item.thisTimeCostPrice);
    if (this.validateGPR(gpr, item)) item.gpr = gpr;

    // 表示更新
    this.dtg_SelectionGoodsList.refresh();
  }

  /**
   * 計画供給高_変更時に呼び出される
   *
   * @memberof KYMW7001Component
   */
  public eventPlanSupplyBudget_CHANGEHandler(item: any): void {
    this.eventEditHandler();

    // GPRの計算
    const gpr = this.calculateGPR(item.planSupplyBudget, item.predictPlanNum, item.planNum, item.thisTimeCostPrice);
    if (this.validateGPR(gpr, item)) item.gpr = gpr;
    
    this.dtg_SelectionGoodsList.refresh();
  }

  /**
   * GPRの判定
   * 
   * @param gpr 
   * @param item 
   * @returns 
   * @memberof KYMW7001Component
   */
  public validateGPR(gpr: string, item: any): boolean {
    const isGprValid = this.convertStrToNum(gpr) >= 0;
    if (!isGprValid) {
      this.dialogService.openAlertGetMessage('E0622');
      item.planSupplyBudget = '';
      item.dispPlanSupplyBudget = '';
    }
    return isGprValid;
  }

  /**
   * 依頼先バイヤー_変更時に呼び出される
   * 
   * @memberof KYMW7001Component
   */
  public eventRequestBuyer_CHANGEHandler(item: any): void {
    if (item.requestBuyer === 'blankVal') item.requestBuyer = '';
  }

  /**
   * 選定商品一覧.全選択チェック処理
   */
  public eventSelectionListAll_CLICKHandler(): void {
    const selectionList = this.kymw7001Model.SelectionList;

    if (selectionList != null) {
      selectionList.forEach((item)=> {
        if (this.kymw7001Model.selectionListAll) {
          item.check = true;
        } else {
          item.check = false;
        }
      })
      this.eventEditHandler();
      this.kymw7001Model.SelectionList = [...selectionList];
    }
  }

  /**
   * 選定商品一覧.チェック処理
   *
   */
  public eventSelectionListChk_CLICKHandler(): void {
    const selectionList = this.kymw7001Model.SelectionList;
    selectionList.forEach((item)=> {
      if (!item.check) {
        this.kymw7001Model.selectionListAll = false;
      }
    })
  }

  /**
   * ボタン押下 表示
   *
   * @memberof KYMW7001Component
   */
  public eventDisplay_CLICKHandler() {
    // バリデーション 必須チェック
    if (this.kymw7001Model.catalogId === '') {
      this.dialogService.openAlertGetMessage('W0001', ['企画回']);
      return;
    }
    if (!this.isValidMediumType()) {
      this.dialogService.openAlertGetMessage('W0001', ['媒体']);
      return;
    }

    const loginBuyerList = this.kymw00Model.kymw1001Model.loginUserInfo.BuyerCodeList;

    if (!loginBuyerList.length) {
      this.dialogService.openAlertGetMessage('W0062');
      return;
    }

    // 特集が入陸されていないときいは特集情報を取得しない
    if (!this.isValidFeatureCode()) {
      // 表紙特集選定商品一覧取得
      this.getSelectionGoodsListByBuyerService.execute(this.kymw7001Model, loginBuyerList, 
        (data: GetSelectionGoodsListByBuyerResponse) => this.initSelectionGoodsList(data)
      );
      this.kymw7001Model.featureMemo = '';
      this.featureMemoDisable = false;
    } else {
      // 特集情報取得
      this.getFeatureThemaByBuyerService.execute(this.kymw7001Model,() => {
        // 表紙特集選定商品一覧取得
        this.getSelectionGoodsListByBuyerService.execute(this.kymw7001Model, loginBuyerList, 
          (data: GetSelectionGoodsListByBuyerResponse) => this.initSelectionGoodsList(data)
        );
      });
      this.featureMemoDisable = true;
    }
  }

  /**
   * 差替え対象一覧取得成功時
   * @param chkSelectionList 
   */
  public successGetReplacementList(data: GetReplacementListResponse) {
    const ReplacementList = [];
    data.forEach(item => {
      const addData = new ReplacementListInfo();
      addData.requestBuyer = null;
      // 担当者名取得
      const person = this.kymw7001Model.BuyreCodeList.filter(
        buyerItem => buyerItem.CodeValue == item.RequestBuyer);
      addData.person = person.length == 1 ? person[0].CodeName : null;
      addData.buyerRequestId = item.BuyerRequestId;
      addData.featureCode = item.FeatureCode;
      addData.featureName = item.FeatureName;
      addData.formatFeature = this.formatCodeName(item.FeatureCode, item.FeatureName);
      addData.classCode = item.ClassCode;
      addData.classNameKanji = item.ClassName;
      addData.formatClass = this.formatCodeName(item.ClassCode, item.ClassName);
      addData.middleClassCode = item.MiddleClassCode;
      addData.middleClassNameKanji = item.MiddleClassName;
      addData.formatMiddleClass = this.formatCodeName(item.MiddleClassCode, item.MiddleClassName);
      addData.pCode = item.PCode;
      addData.itemCode = item.ItemCode;
      addData.guideGoodsName = item.GuideGoodsName;
      addData.guideStandardName = item.GuideStandardName;
      const pricePattern = this.kymw7001Model.PricePetternList.filter(
        priceItem => priceItem.CodeValue == item.PricePattern);
      addData.pricePattern = pricePattern.length == 1 ? pricePattern[0].CodeName : null;
      addData.thisTimeSupplyPrice = item.ThisTimeSupplyPrice;
      addData.thisTimeCostPrice = item.ThisTimeCostPrice;
      addData.predictPlanNum = item.PredictPlanNum;
      const planNum = item.PlanNum;
      addData.planNum = planNum;
      addData.planSupplyBudget = item.PlanSupplyBudget;
      addData.dispPlanSupplyBudget = this.setDispPlanSupplyBudget(item.PlanSupplyBudget);
      addData.gpr = 
        this.calculateGPR(item.PlanSupplyBudget, item.PredictPlanNum, item.PlanNum, item.ThisTimeCostPrice);
      addData.remarks = item.Remarks;
      addData.requestStatus = this.getRequestStatus(item.RequestStatus);
      ReplacementList.push(addData);
    })
    this.kymw7001Model.ReplacementList = ReplacementList;
    this.clearEditCount();
  }

  /**
   * ボタン押下 却下
   *
   * @memberof KYMW7001Component
   */
  public eventRejection_CLICKHandler() {
    const chkSelectionList = this.kymw7001Model.SelectionList.filter(_ => _.check);
    if (chkSelectionList.length >= 1) {
      if (this.rejectionValidate()) {
        this.dialogService.openAlertGetMessage(
          'Q0108', ['表紙特集商品選定情報'],
          (closeDetail) => {
            if (closeDetail === PlessAlert.Yes) {
              const loginBuyerList = this.kymw00Model.kymw1001Model.loginUserInfo.BuyerCodeList;
              this.rejectionFeatureInfoService.execute(this.kymw7001Model, loginBuyerList, chkSelectionList,
                () => this.successRejection(chkSelectionList));
            }
          }
        );
      }
    }

    // 全選択チェックを外す
    this.kymw7001Model.selectionListAll = false;
  }

  /**
   * 却下処理成功時
   * @param chkSelectionList 
   */
  public successRejection(chkSelectionList: SelectionListInfo[]) {
    const updateReplacementList = [...this.kymw7001Model.ReplacementList];
    
    // 差替え対象一覧に追加
    chkSelectionList.forEach((updateItem) => {
      const addList = new ReplacementListInfo();
      addList.featureCode = this.kymw7001Model.featureCode;
      addList.featureName = this.getFeatureName();
      addList.formatFeature = this.formatCodeName(this.kymw7001Model.featureCode, this.getFeatureName());
      addList.classCode = updateItem.classCode;
      addList.classNameKanji = updateItem.classNameKanji;
      addList.formatClass = this.formatCodeName(updateItem.classCode, updateItem.classNameKanji);
      addList.middleClassCode = updateItem.middleClassCode;
      addList.middleClassNameKanji = updateItem.classNameKanji;
      addList.formatMiddleClass = this.formatCodeName(updateItem.middleClassCode, updateItem.classNameKanji);
      addList.pCode = updateItem.pCode;
      addList.itemCode = updateItem.itemCode;
      addList.guideGoodsName = updateItem.guideGoodsName;
      addList.guideStandardName = updateItem.guideStandardName;
      const pricePattern = this.kymw7001Model.PricePetternList.filter(
        priceItem => priceItem.CodeValue == updateItem.pricePattern);
      addList.pricePattern = pricePattern.length == 1 ? pricePattern[0].CodeName : null;
      addList.thisTimeSupplyPrice = updateItem.thisTimeSupplyPrice;
      addList.thisTimeCostPrice = updateItem.thisTimeCostPrice;
      addList.predictPlanNum = updateItem.predictPlanNum;
      addList.planNum = updateItem.planNum;
      addList.planSupplyBudget = updateItem.planSupplyBudget;
      addList.dispPlanSupplyBudget = this.setDispPlanSupplyBudget(updateItem.planSupplyBudget);
      addList.gpr = 
        this.calculateGPR(updateItem.planSupplyBudget, updateItem.predictPlanNum, updateItem.planNum, updateItem.thisTimeCostPrice);
      addList.remarks = updateItem.remarks;
      addList.requestStatus = this.getRequestStatus("0");
      
      updateReplacementList.push(addList)
    })

    this.kymw7001Model.ReplacementList = updateReplacementList;

    // 選定商品一覧から削除
    const selectionList = this.kymw7001Model.SelectionList.filter(_ => !_.check);
    this.kymw7001Model.SelectionList = selectionList;
  }

  /**
   * 却下時のバリデート
   */
  public rejectionValidate(): boolean {
    // 必須チェック
    if (!this.txt_OrderCode.isValidOrderCode()) {
      this.dialogService.openAlertGetMessage('W0001', ['受注コード']);
      return false;
    }
    if (!this.isValidMediumType()) {
      this.dialogService.openAlertGetMessage('W0001', ['媒体']);
      return false;
    }
    if (!this.kymw00Model.kymw1001Model.loginUserInfo.BuyerCodeList.length) {
      this.dialogService.openAlertGetMessage('W0062');
      return false;
    }
    return true;
  }

  /**
   * ボタン押下 承認
   *
   * @memberof KYMW7001Component
   */
  public eventApproval_CLICKHandler() {
    const chkSelectionList = this.kymw7001Model.SelectionList.filter(_ => _.check);
    if (chkSelectionList.length >= 1) {
      if (this.approvalValidate(chkSelectionList)) {
        this.dialogService.openAlertGetMessage(
          'Q0108', ['表紙特集商品選定情報'],
          (closeDetail) => {
            if (closeDetail === PlessAlert.Yes) {
              const loginBuyerList = this.kymw00Model.kymw1001Model.loginUserInfo.BuyerCodeList;
              this.approvalFeatureInfoService.execute(this.kymw7001Model, loginBuyerList, chkSelectionList,
                () => {
                  // 承認した行を選定商品一覧から削除
                  const selectionList = this.kymw7001Model.SelectionList.filter(_ => !_.check);
                  this.kymw7001Model.SelectionList = selectionList;
                }
              );
            }
          }
        );
      }  
    }
  }

  /**
   * 承認時のバリデート
   */
  public approvalValidate(chkSelectionList: SelectionListInfo[]): boolean {
    // 必須チェック
    if (!this.txt_OrderCode.isValidOrderCode()) {
      this.dialogService.openAlertGetMessage('W0001', ['受注コード']);
      return false;
    }
    if (!this.isValidMediumType()) {
      this.dialogService.openAlertGetMessage('W0001', ['媒体']);
      return false;
    }
    if (!this.kymw00Model.kymw1001Model.loginUserInfo.BuyerCodeList.length) {
      this.dialogService.openAlertGetMessage('W0062');
      return false;
    }

    // バリデーション 選定商品エリア
    for (const item of chkSelectionList) {
      if (PlessViewUtilsSub.isEmpty(item.pricePattern) || item.pricePattern === 'blankVal') {
        this.dialogService.openAlertGetMessage('W0001', ['価格パターン']);
        return false;
      } else if (!item.thisTimeSupplyPrice) {
        this.dialogService.openAlertGetMessage('W0001', ['今回供給価格']);
        return false;
      } else if (!item.thisTimeCostPrice) {
        this.dialogService.openAlertGetMessage('W0001', ['仕入価']);
        return false;
      } else if (PlessViewUtilsSub.isEmpty(item.predictPlanNum) && PlessViewUtilsSub.isEmpty(item.planNum)) {
        this.dialogService.openAlertGetMessage('W0001', ['計画数(予測)が未設定の場合に計画数(修正)']);
        return false;
      } else if (this.isNaNString(item.thisTimeSupplyPrice)) {
        this.dialogService.openAlertGetMessage('W0024', ['今回供給価格']);
        return false;
      } else if (this.isNaNString(item.thisTimeCostPrice)) {
        this.dialogService.openAlertGetMessage('W0024', ['仕入価']);
        return false;
      } else if (this.isNaNString(item.planNum)) {
        this.dialogService.openAlertGetMessage('W0024', ['計画数(修正)']);
        return false;
      } else if (!this.isMaxLength(item.thisTimeSupplyPrice, 7)) {
        this.dialogService.openAlertGetMessage('W0007', ['今回供給価格','7']);
        return false;
      } else if (!this.isValidThisTimeCostPrice(item.thisTimeCostPrice)) {
        return false;
      } else if (!this.isMaxLength(item.planNum, 7)) {
        this.dialogService.openAlertGetMessage('W0007', ['計画数(修正)', '7']);
        return false;
      } else if (!this.isMaxLength(item.planSupplyBudget, 100)) {
        this.dialogService.openAlertGetMessage('W0007', ['備考', '100']);
        return false;
      }
    }

    return true;
  }

  /**
   * 仕入価のバリデーション
   *
   * @memberof KYMW7001Component
   */
  private isValidThisTimeCostPrice(thisTimeCostPrice: string): boolean {
    const tmp = thisTimeCostPrice.split('.');
    if (tmp[0].length > 7) {
      // 整数部のチェック
      this.dialogService.openAlertGetMessage('W0015', ['仕入価','7', '2']);
      return false;
    }
    if (tmp.length > 1 && tmp[1].length > 2) {
      // 小数部のチェック
      this.dialogService.openAlertGetMessage('W0015', ['仕入価','7', '2']);
      return false;
    }
    return true;
  }

  /**
   * ボタン押下 選定依頼
   *
   * @memberof KYMW7001Component
   */
  public eventFeatureRequest_CLICKHandler() {
    if (!(this.dtg_ReplacementList.selectedItems[0] instanceof ReplacementListInfo)) return;
    const selectItem = this.dtg_ReplacementList.selectedItems[0];
    // 必須チェック
    if (!selectItem.requestBuyer) {
      this.dialogService.openAlertGetMessage('W0001', ['依頼先バイヤー']);
    } else {
      this.dialogService.openAlertGetMessage(
        'Q0104', ['選定依頼'],
        (closeDetail) => {
          if (closeDetail === PlessAlert.Yes) {
            // 選定依頼処理
            this.registFeatureRequestBuyerService.execute(this.kymw7001Model, selectItem,
              () => this.successFeatureRequest());  
          }
        }
      );
    }
  }

  /**
   * 選定依頼処理成功時
   * 
   * @param selectItem 
   */
  public successFeatureRequest() {
    // 差し替え対象一覧取得
    const loginBuyerList = this.kymw00Model.kymw1001Model.loginUserInfo.BuyerCodeList;
    this.getReplacementListService.execute(this.kymw7001Model, loginBuyerList, 
      (data: GetReplacementListResponse) => this.successGetReplacementList(data)
    );
  }

  /**
   * ボタン押下 商品選定
   *
   * @memberof KYMW7001Component
   */
  public eventGoodsSelect_CLICKHandler() {
    const selectItem = this.dtg_ReplacementList.selectedItems[0];
    this.getReplacementGoodsService.execute(this.kymw7001Model, selectItem,
      (data: GetReplacementGoodsResponse) => this.successGoodsSelect(data));
  }

  /**
   * 商品選定処理成功時
   * 
   * @param data 
   */
  public successGoodsSelect(data: GetReplacementGoodsResponse) {
    const addItem = new SelectionListInfo();
    addItem.featureCode = this.kymw7001Model.featureCode;
    addItem.featureName = this.getFeatureName();
    addItem.formatFeature = this.formatCodeName(this.kymw7001Model.featureCode, this.getFeatureName()); 
    addItem.classCode = data[0].ClassCode;
    addItem.classNameKanji = data[0].ClassName;
    addItem.formatClass = this.formatCodeName(data[0].ClassCode, data[0].ClassName);
    addItem.middleClassCode = data[0].MiddleClassCode;
    addItem.middleClassNameKanji = data[0].MiddleClassName;
    addItem.formatMiddleClass = this.formatCodeName(data[0].MiddleClassCode, data[0].MiddleClassName);
    addItem.pCode = data[0].PCode;
    addItem.itemCode = data[0].ItemCode;
    addItem.guideGoodsName = data[0].GuideGoodsName;
    addItem.guideStandardName = data[0].GuideStandardName;
    const pricePattern = this.kymw7001Model.PricePetternList.filter(
      priceItem => priceItem.CodeValue == data[0].PricePattern);
    addItem.pricePattern = pricePattern.length == 1 ? pricePattern[0].CodeName : null;
    addItem.thisTimeSupplyPrice = data[0].ThisTimeSupplyPrice;
    addItem.thisTimeCostPrice = data[0].ThisTimeCostPrice;
    addItem.predictPlanNum = data[0].PredictPlanNum;
    const planNum = this.kymw7001Model.mediumType === "018" ? data[0].StockNum : data[0].PlanNum;
    addItem.planNum = planNum;
    addItem.planSupplyBudget = data[0].PlanSupplyBudget;
    addItem.dispPlanSupplyBudget = this.setDispPlanSupplyBudget(data[0].PlanSupplyBudget);
    addItem.tagName = data[0].TagName;
    addItem.remarks = data[0].Remarks;
    addItem.selectorType = data[0].SelectorType;
    addItem.buyerRequestId = data[0].BuyerRequestId;
    addItem.gpr = 
      this.calculateGPR(data[0].PlanSupplyBudget, data[0].PredictPlanNum, 
                        data[0].PlanNum, data[0].ThisTimeCostPrice);
    this.kymw7001Model.SelectionTargetList = [addItem];

    this.kymw7001Model.SelectionList = [];

    this.mode = false;
  }

  /**
   * 選定商品一覧初期設定
   */
  public initSelectionGoodsList(data: GetSelectionGoodsListByBuyerResponse) {
    const selectionList = [];
    data.forEach(item => {
      const addData = new SelectionListInfo();
      addData.featureCode = item.FeatureCode;
      addData.featureName = item.FeatureName;
      addData.formatFeature = this.formatCodeName(item.FeatureCode, item.FeatureName);
      addData.classCode = item.ClassCode;
      addData.classNameKanji = item.ClassName;
      addData.formatClass = this.formatCodeName(item.ClassCode, item.ClassName);
      addData.middleClassCode = item.MiddleClassCode;
      addData.middleClassNameKanji = item.MiddleClassName;
      addData.formatMiddleClass = this.formatCodeName(item.MiddleClassCode, item.MiddleClassName);
      addData.pCode = item.PCode;
      addData.guideGoodsName = item.GuideGoodsName;
      addData.guideStandardName = item.GuideStandardName;
      addData.pricePattern = item.PricePattern;
      addData.isChangedPricePattern = item.IsChangedPricePattern;
      addData.thisTimeSupplyPrice = item.ThisTimeSupplyPrice;
      addData.supplyPriceStandard = item.SupplyPriceStandard;
      addData.supplyPriceSpecial1 = item.SupplyPriceSpecial1;
      addData.supplyPriceSpecial2 = item.SupplyPriceSpecial2;
      addData.isChangedSupplyPrice = item.IsChangedSupplyPrice;
      addData.thisTimeCostPrice = item.ThisTimeCostPrice;
      addData.costPriceStandard = item.CostPriceStandard;
      addData.costPriceSpecial1 = item.CostPriceSpecial1;
      addData.costPriceSpecial2 = item.CostPriceSpecial2;
      addData.isChangedCostPrice = item.IsChangedCostPrice;
      addData.predictPlanNum = item.PredictPlanNum;
      const planNum = this.kymw7001Model.mediumType === "018" ? item.StockNum : item.PlanNum;
      addData.planNum = planNum;
      addData.isChangedPlanNum = item.IsChangedPlanNum;
      addData.planSupplyBudget = item.PlanSupplyBudget;
      addData.dispPlanSupplyBudget = this.setDispPlanSupplyBudget(item.PlanSupplyBudget);
      addData.isChangedPlanSupplyBudget = item.IsChangePlanSupplyBudget;
      addData.gpr = 
        this.calculateGPR(item.PlanSupplyBudget, item.PredictPlanNum, item.PlanNum, item.ThisTimeCostPrice);
      addData.tagName = item.TagName;
      addData.remarks = item.Remarks;
      addData.selectorType = item.SelectorType;
      addData.buyerRequestId = item.BuyerRequestId;
      addData.itemCode = item.ItemCode;
      selectionList.push(addData);
    })
    this.kymw7001Model.SelectionList = selectionList;

    // 全選択チェックを外す
    this.kymw7001Model.selectionListAll = false;

    // 差し替え対象一覧取得
    const loginBuyerList = this.kymw00Model.kymw1001Model.loginUserInfo.BuyerCodeList;
    this.getReplacementListService.execute(this.kymw7001Model, loginBuyerList, 
      (data: GetReplacementListResponse) => { 
        this.successGetReplacementList(data);
        // 選定商品一覧と差し替え対象一覧がともに0件の場合
        if (PlessViewUtilsSub.isEmptyArray(this.kymw7001Model.SelectionList) && PlessViewUtilsSub.isEmptyArray(this.kymw7001Model.ReplacementList)) {
          this.dialogService.openAlertGetMessage('E0100');
        }
      }
    );
  }

  /**
   * 活性制御
   * @param mode true: 閲覧、false: 登録
   */
  public enableMode(mode: boolean): void  {
    this.btn_Search.nativeElement.disabled = mode;
    this.btn_Selection.nativeElement.disabled = mode;
    this.btn_SelectionCannel.nativeElement.disabled = mode;
    this.btn_Confirm.nativeElement.disabled = mode;

  }

  /**
   * ボタン押下 商品検索
   *
   * @memberof KYMW7001Component
   */
  public eventSeach_CLICKHandler() {
    if (this.kymw7001Model.SelectionTargetList.length > 0) {
      this.eventEditHandler();
      if (this.kymw0300InputVO === null) {
        this.kymw0300InputVO = new KYMW0300InputModel();
      }
      // 企画関連条件を表示する（企画検索フラグ:1）
      this.kymw0300InputVO.catalogSearchFlg = 1;
      // 商品検索画面(モーダレス)を表示する。
      this.kymw0300ComponentRef =
        this.dialogService.openModelessSub(
          this, KYMW0300Component,
          this.viewContainerRef, this.kymw0300ComponentRef, null, 0, '', true
        );
      if (this.kymw0300ComponentRef != null) {
        this.kymw0300Component = this.kymw0300ComponentRef.instance as KYMW0300Component;
        this.kymw0300Component.parent = this;
        this.kymw0300Component.setInterfaceParam(this.kymw0300InputVO);
        this.kymw0300Component.setKYMW0300Parameter =
          (outputVO: KYMW0300OutputModel) => {
            this.kymw0300InputVO = this.kymw0300Model.getKYMW0300SearchHistory(outputVO);
            this.getTargetListByFeatureGoodsSelectionService.execute(this.kymw7001Model, outputVO, 
              (data: GetTargetListByFeatureGoodsSelectionResponse) => this.successGetTargetList(data)
            );
          };
        // ウィンドウが閉じられる際の処理
        this.kymw0300Component.closeFunction = () => {
          this.kymw0300ComponentRef.destroy();
        };
      }
    }
  }

  /**
   * 商品検索処理成功時
   * @param data 
   */
  public successGetTargetList(list: GetTargetListByFeatureGoodsSelectionResponse) {
    // 選定済商品チェック
    this.checkFeatureGoodsSelectionService.execute(this.kymw7001Model, list, (data: CheckFeatureGoodsSelectionResponse) => {

      //null要素を除外
      const filteredCheckList = data.filter(v => v);

      const updateList = [];
      list.map(item => {
        const addData = new TargetListInfo();
        // 選定済の場合は非活性に変更
        addData.checkFlag = filteredCheckList.find(v => v.PCode === item.PCode) !== undefined;
        addData.check = false;
        addData.pCode = item.PCode;
        addData.itemCode = item.ItemCode;
        addData.guideGoodsName = item.GuideGoodsName;
        addData.guideStandardName = item.GuideStandardName;
        addData.classCode = item.ClassCode;
        addData.classNameKanji = item.ClassNameKanji;
        addData.formatClass = this.formatCodeName(item.ClassCode, item.ClassNameKanji);
        addData.largeClassCode = item.LargeClassCode;
        addData.largeClassNameKanji = item.LargeClassNameKanji;
        addData.formatLargeClass = this.formatCodeName(item.LargeClassCode, item.LargeClassNameKanji);
        addData.middleClassCode = item.MiddleClassCode;
        addData.middleClassNameKanji = item.MiddleClassNameKanji;
        addData.formatMiddleClass = this.formatCodeName(item.MiddleClassCode, item.MiddleClassNameKanji);
        addData.smallClassCode = item.SmallClassCode;
        addData.smallClassNameKanji = item.SmallClassNameKanji;
        addData.formatSmallClass = this.formatCodeName(item.SmallClassCode, item.SmallClassNameKanji);
        addData.tagName = item.TagName;
        addData.supplyPriceStandard = item.SupplyPriceStandard;
        addData.supplyPriceSpecial1 = item.SupplyPriceSpecial1;
        addData.supplyPriceSpecial2 = item.SupplyPriceSpecial2;
        addData.costPriceStandard = item.CostPriceStandard;
        addData.costPriceSpecial1 = item.CostPriceSpecial1;
        addData.costPriceSpecial2 = item.CostPriceSpecial2;
        updateList.push(addData)
      })
      this.kymw7001Model.TargetListInfo = updateList;
    });
  }

  /**
   * コードと名称の整形処理
   * 
   * @param code 
   * @param name 
   * @returns code: name
   */
  public formatCodeName(code: string, name: string) {
    if (!PlessViewUtils.isEmpty(code) && !PlessViewUtils.isEmpty(name)) {
      return code + ": " + name
    }
  }

  /**
   * ボタン押下 選定
   *
   * @memberof KYMW7001Component
   */
  public eventSelection_CLICKHandler() {
    let checkTargetListInfo = this.kymw7001Model.TargetListInfo.filter(_ => _.check);

    // 選択状態チェック
    if (checkTargetListInfo.length > 1) {
      this.dialogService.openAlertGetMessage('E0201', ["候補一覧", "1"],
        (closeDetail: any): void => {
          if (closeDetail === PlessAlert.Yes_Error) {
            return;
          }
        }
      );
      return;
    } 

    // 取扱終了チェック
    if(!PlessViewUtilsSub.isEmptyArray(checkTargetListInfo)) {
      let normalPcode = []
      this.checkFeatureSelectionService.execute(this.kymw7001Model,
        (data: any) => {
          normalPcode = data.NormalPCodeList;
          if (normalPcode.length !== checkTargetListInfo.length) {
            this.dialogService.openAlertGetMessage("I0524");
          }
          // 取扱終了しているデータを削除する
          checkTargetListInfo = 
            checkTargetListInfo.filter(item => normalPcode.some(obj => obj.PCode === item.pCode));
          // 既に選定商品一覧に存在しているデータを削除
          checkTargetListInfo = 
            checkTargetListInfo.filter(item => !this.kymw7001Model.SelectionList.some(obj => obj.pCode === item.pCode));

          // 選定商品一覧、選定対象の非存在チェック
          let selectionMatch = [];
          let targetMatch = [];
          checkTargetListInfo.forEach((addItem) => {
            selectionMatch = this.kymw7001Model.SelectionList.filter(item => item.pCode === addItem.pCode);
            targetMatch = this.kymw7001Model.SelectionTargetList.filter(item => item.pCode === addItem.pCode);
          })
          if (selectionMatch.length == 0 && targetMatch.length == 0) {
            // 予測計画数取得
            this.getGoodsPlanNumService.execute(this.kymw7001Model, checkTargetListInfo,
              (data) => this.successGetGoodsPlanNumService(checkTargetListInfo, data));
          }
          this.eventEditHandler();
        }
      );
    }
  }

  /**
   * 計画数(予測)取得の成功時処理
   * 
   * @param checkTargetListInfo 
   * @param data 
   */
  public successGetGoodsPlanNumService(checkTargetListInfo: TargetListInfo[], data: { PlanNumList: { PlanNumAiPrediction: string; }[]; }) {
    // 選定商品一覧に設定
    const addItem = new SelectionListInfo();
    addItem.featureCode = this.kymw7001Model.featureCode;
    addItem.featureName = this.getFeatureName();
    addItem.formatFeature = this.formatCodeName(this.kymw7001Model.featureCode, this.getFeatureName()); 
    addItem.classCode = checkTargetListInfo[0].classCode;
    addItem.classNameKanji = checkTargetListInfo[0].classNameKanji;
    addItem.formatClass = this.formatCodeName(checkTargetListInfo[0].classCode, checkTargetListInfo[0].classNameKanji);
    addItem.middleClassCode = checkTargetListInfo[0].middleClassCode;
    addItem.middleClassNameKanji = checkTargetListInfo[0].middleClassNameKanji;
    addItem.formatMiddleClass = this.formatCodeName(checkTargetListInfo[0].middleClassCode, checkTargetListInfo[0].middleClassNameKanji);
    addItem.pCode = checkTargetListInfo[0].pCode;
    addItem.guideGoodsName = checkTargetListInfo[0].guideGoodsName;
    addItem.guideStandardName = checkTargetListInfo[0].guideStandardName;
    addItem.predictPlanNum = !PlessViewUtils.isEmptyArray(data.PlanNumList) ? data.PlanNumList[0].PlanNumAiPrediction : '';
    addItem.tagName = checkTargetListInfo[0].tagName;
    addItem.itemCode = checkTargetListInfo[0].itemCode;
    addItem.supplyPriceStandard = checkTargetListInfo[0].supplyPriceStandard;
    addItem.supplyPriceSpecial1 = checkTargetListInfo[0].supplyPriceSpecial1;
    addItem.supplyPriceSpecial2 = checkTargetListInfo[0].supplyPriceSpecial2;
    addItem.costPriceStandard = checkTargetListInfo[0].costPriceStandard;
    addItem.costPriceSpecial1 = checkTargetListInfo[0].costPriceSpecial1;
    addItem.costPriceSpecial2 = checkTargetListInfo[0].costPriceSpecial2;

    const updateList = [];
    updateList.push(addItem);

    this.kymw7001Model.SelectionList = updateList;
  }

  /**
   * 検索条件エリアの特集名を取得
   * 
   * @returns 
   */
  public getFeatureName() {
    const featureElement = document.getElementById("cmb_FeatureType")
    const selectElement = featureElement.firstElementChild as HTMLSelectElement;
    const featureText = selectElement.options[selectElement.selectedIndex].text
    const featureName = featureText.split(':');
    return featureName[1];
  }

  /**
   * ボタン押下 選定解除
   *
   * @memberof KYMW7001Component
   */
  public eventSelectionCannel_CLICKHandler() {
    this.eventEditHandler();
    
    // 選択した行を削除する
    this.kymw7001Model.SelectionList = [];
  }

  /**
   * ボタン押下 確定
   *
   * @memberof KYMW7001Component
   */
  public eventConfirm_CLICKHandler() {
    this.eventEditHandler();
    if (this.kymw7001Model.SelectionList.length > 0) {
      if (this.confirmValidate()) {
        this.dialogService.openAlertGetMessage(
          'Q0108', ['表紙特集商品選定情報'],
          (closeDetail) => {
            if (closeDetail === PlessAlert.Yes) {
              const loginBuyerList = this.kymw00Model.kymw1001Model.loginUserInfo.BuyerCodeList;
              this.ConfirmFeatureGoodsByBuyerService.execute(this.kymw7001Model, loginBuyerList,
                () => this.successConfirm());
            }
          }
        );
      }
    }    
  }

  /**
   * 確定処理成功時
   */
  public successConfirm() {
    this.dialogService.openAlertGetMessage(
      'I0508', ["選定の確定"],
      (closeDetail: any): void => {
        if (closeDetail === PlessAlert.Yes) {
          if (PlessViewUtils.isEmpty(this.kymw7001Model.SelectionTargetList[0].buyerRequestId)) {
            // 確認モードへ変更
            this.changeConfirmMode()
          } else {
            // 依頼確認画面へ遷移
            this.route.navigate(['/kymw/7007'], {
              queryParams: {
                orderCode: this.kymw7001Model.orderCode,
                mediumType: this.kymw7001Model.mediumType,
              },
            });
          }
        }
      });
  }

  /**
   * 選定確定後の確認モードへの変更処理
   */
  public changeConfirmMode() {
    this.editFlag = false;
    this.mode = true;
    this.eventDisplay_CLICKHandler()
    this.kymw7001Model.TargetListInfo = [];
  }

  /**
   * 確定時のバリデート
   */
  public confirmValidate(): boolean {

    // バリデーション 選定商品エリア
    for(const item of this.kymw7001Model.SelectionList) {
      // 必須チェック
      if (PlessViewUtilsSub.isEmpty(item.pricePattern) || item.pricePattern === 'blankVal') {
        this.dialogService.openAlertGetMessage('W0001', ['価格パターン']);
        return false;
      } else if (!item.thisTimeSupplyPrice) {
        this.dialogService.openAlertGetMessage('W0001', ['今回供給価格']);
        return false;
      } else if (!item.thisTimeCostPrice) {
        this.dialogService.openAlertGetMessage('W0001', ['仕入価']);
        return false;
      } else if (!item.planSupplyBudget) {
        this.dialogService.openAlertGetMessage('W0001', ['計画供給高']);
        return false;
      } else if (this.isNaNString(item.thisTimeSupplyPrice)) {
        this.dialogService.openAlertGetMessage('W0024', ['今回供給価格']);
        return false;
      } else if (this.isNaNString(item.thisTimeCostPrice)) {
        this.dialogService.openAlertGetMessage('W0024', ['仕入価']);
        return false;
      } else if (this.isNaNString(item.planNum)) {
        this.dialogService.openAlertGetMessage('W0024', ['計画数(修正)']);
        return false;
      } else if (this.isNaNString(item.planSupplyBudget)) {
        this.dialogService.openAlertGetMessage('W0024', ['計画供給高']);
        return false;
      } else if (!this.isMaxLength(item.thisTimeSupplyPrice, 7)) {
        this.dialogService.openAlertGetMessage('W0007', ['今回供給価格','7']);
        return false;
      } else if (!this.isMaxLength(item.thisTimeCostPrice, 7)) {
        this.dialogService.openAlertGetMessage('W0007', ['仕入価','7']);
        return false;
      } else if (!this.isMaxLength(item.planNum, 7)) {
        this.dialogService.openAlertGetMessage('W0007', ['計画数(修正)', '7']);
        return false;
      } else if (!this.isMaxLength(item.planSupplyBudget, 11)) {
        this.dialogService.openAlertGetMessage('W0007', ['計画供給高', '11']);
        return false;
      } else if (!this.isMaxLength(item.planSupplyBudget, 100)) {
        this.dialogService.openAlertGetMessage('W0007', ['備考', '100']);
        return false;
      }
    }

    if (!this.kymw00Model.kymw1001Model.loginUserInfo.BuyerCodeList.length) {
      this.dialogService.openAlertGetMessage('W0062');
      return false;
    }

    return true;
  }

  /**
   * GPR計算
   * (計画供給高 -（計画数 * 仕入価)) / 計画供給高 で計算。
   * @param planSupplyBudget 
   * @param predictPlanNum
   * @param planNum 
   * @param thisTimeCostPrice 
   */
  public calculateGPR(planSupplyBudget: string, predictPlanNum: string, planNum: string, thisTimeCostPrice: string): string {
    if (
      PlessViewUtilsSub.isEmpty(planSupplyBudget) &&
      PlessViewUtilsSub.isEmpty(thisTimeCostPrice) &&
      (PlessViewUtilsSub.isEmpty(predictPlanNum) || PlessViewUtilsSub.isEmpty(planNum))
    ) {
      // 計画供給高が入力されていない。かつ、仕入価が入力されていない。
      // かつ、計画数(予測)か、計画数(修正)が入力されていない場合
      return null;
    }
  
    // 計画供給高
    const numPlanSupplyBudget = this.convertStrToNum(planSupplyBudget);
    // 計画供給高が0の場合は0を返す(0割り対策)
    if (numPlanSupplyBudget === 0) {
      return "0.0";
    }

    // 計画数
    let numPlanNum = 0;
    if (!PlessViewUtilsSub.isEmpty(planNum)) {
      // 計画数(修正)が入力されている場合
      numPlanNum = this.convertStrToNum(planNum);
    } else if(!PlessViewUtilsSub.isEmpty(predictPlanNum)) {
      // 計画数(予測)が入力されている場合
      numPlanNum = this.convertStrToNum(predictPlanNum);
    }

    // 仕入価
    const numThisTimeCostPrice = this.convertStrToNum(thisTimeCostPrice);

    // GPR計算(小数第一位まで)
    let gpr = (numPlanSupplyBudget - (numPlanNum * numThisTimeCostPrice)) / numPlanSupplyBudget * 100;
    gpr = (Math.round(gpr * 10) / 10);

    return gpr.toFixed(1);
  }

  /**
   * 計画供給高計算
   */
  public calculatePlanSupplyBudget(item: any): void {
    if (!PlessViewUtilsSub.isEmpty(item.thisTimeSupplyPrice)) {
      if (!PlessViewUtilsSub.isEmpty(item.planNum)) {
        item.planSupplyBudget = String(this.convertStrToNum(item.thisTimeSupplyPrice) * this.convertStrToNum(item.planNum));
      } else if (!PlessViewUtilsSub.isEmpty(item.predictPlanNum)) {
        item.planSupplyBudget = String(this.convertStrToNum(item.thisTimeSupplyPrice) * this.convertStrToNum(item.predictPlanNum));
      } else {
        item.planSupplyBudget = '';
      }
    } else {
      item.planSupplyBudget = '';
    }

    // 計画供給高（千円）を設定
    item.dispPlanSupplyBudget = this.setDispPlanSupplyBudget(item.planSupplyBudget);
  }

  /**
   * 数値でないかどうかを判定する(String版)
   * [戻り値]true：数値ではない／false：数値
   *
   * @param value 判定する文字列
   */
  public isNaNString(value: string): boolean {
    return isNaN(Number(value));
  }

   /**
   * 文字列の桁数チェック
   * @param value : 対象文字列
   * @param value : 最大桁数
   * @return true : 桁数正常
   *         false : 桁数オーバー
   */
  public isMaxLength(value: string, num: number): boolean {
    let result = true;
    if (!PlessViewUtilsSub.isEmpty(value)) {
      if (value.length > num) {
        result = false;
      }
    }
    return result;
  }

  /**
   * 文字列から数値の変換
   * @param value 
   * @returns 
   */
  public convertStrToNum(value: string): number {
    return !PlessViewUtilsSub.isEmpty(value) ? Number(value) : 0;
  }

  private isValidMediumType(): boolean {
    return this.kymw7001Model.mediumType !== '' && this.kymw7001Model.mediumType !== 'blankVal';
  }

  private isValidFeatureCode(): boolean  {
    return this.kymw7001Model.featureCode !== '' && this.kymw7001Model.featureCode !== 'blankVal';
  }

  /**
   * 計画供給高から計画供給高（千円）の変換
   * @param planSupplyBudget 
   */
  public setDispPlanSupplyBudget(planSupplyBudget: string): string {
    let retValue = 0;
    retValue = Math.round(Number(planSupplyBudget) * 0.001);
    return String(retValue);
  }
}
